import React from 'react'
import { TextField } from '@mui/material'
import { type BasePhone } from 'services'

interface PhoneTextFieldProps {
  label: string
  value?: string | null
  disabled: boolean
  handlePhoneExtensionChange: (newValue: string) => void
  phone?: BasePhone | null
}

export const PhoneExtensionTextField: React.FC<PhoneTextFieldProps> = ({ label, value, disabled, handlePhoneExtensionChange, phone }) => {
  return (
          <TextField
              id="phone-extension"
              label={label}
              value={value}
              onChange={(e) => { handlePhoneExtensionChange(e.target.value) }}
              variant="outlined"
              disabled={disabled || (phone?.phoneNumber == null || phone.phoneNumber === '')}
              fullWidth
          />
  )
}
